import { useQueries } from "@tanstack/react-query";
import { useMemo } from "react";
import { API } from "@/services/API";

export const useStopsPolyline = (stops) => {
  // zip and stopCoordinates are nullable in the API — routes can only be built between stops that have both
  const routableStops = useMemo(() => (stops ?? []).filter((stop) => stop.zip && stop.stopCoordinates), [stops]);

  const stopPairs = useMemo(() => {
    const pairs = [];
    if (routableStops.length > 1) {
      for (let i = 0; i < routableStops.length - 1; i++) {
        pairs.push({ from: routableStops[i], to: routableStops[i + 1], index: i });
      }
    }
    return pairs;
  }, [routableStops]);

  // Use useQueries to fetch all pairs in parallel with combine option
  // The combine option prevents unnecessary re-renders by memoizing the result
  return useQueries({
    queries: stopPairs.map(({ from, to, index }) => ({
      queryKey: ["stopPolyline", from.zip, to.zip, index],
      queryFn: () =>
        API.get("/marketinfo/market2market-route", {
          params: {
            departure: from.zip.split("-")[0],
            "drop-off": to.zip.split("-")[0],
          },
        }).then((res) => {
          return [...res.polyline, [to.stopCoordinates.longitude, to.stopCoordinates.latitude]];
        }),
      retry: false,
    })),
    combine: (results) => {
      // Check if all queries are successful
      const allSuccessful = results.length > 0 && results.every((result) => result.isSuccess);

      // Return array with data if all successful, empty array otherwise
      if (allSuccessful) {
        let resultsToReturn = [];
        results.forEach((result) => (resultsToReturn = [...resultsToReturn, ...result.data]));
        return [[routableStops[0].stopCoordinates.longitude, routableStops[0].stopCoordinates.latitude], ...resultsToReturn];
      }

      return [];
    },
  });
};
